import React, {useState, useEffect} from 'react'
import DoubleArrowOutlinedIcon from '@mui/icons-material/DoubleArrowOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import _ from 'lodash'


function Adjust(props){
    const [propNav, setPropNav] = useState(props.trueNav)
    const [trueNav, setTrueNav] = useState([])
    const [viewState, setViewState] = useState(true)

    // useEffect(() => {
    //     if (propNav !== []){
    //         makeNav()            
    //     }
    // }, [])

    // async function makeNav(count=0){
    //     let _trueNav = []

    //     async function _makeNav(count){
    //         let nav = propNav
    //         // console.log(propNav)

    //         if (count >= propNav.length){
    //             return
    //         }

    //         let currentElem = nav[count]
    //         let elementToAdd = ""

    //         if (Object.keys(currentElem).includes("label")){
    //             if (currentElem.element === "li" && currentElem.type === "start"){
    //                 elementToAdd = (<li key={currentElem.properties.id}>{await makeElement(count, currentElem)}</li>)    
    //             }

    //             // if (currentElem.label === "D" && currentElem.element === "li" && currentElem.type === "start"){
    //             //     elementToAdd = (<li><ul>{
    //             //         (await make(count, currentElem))
    //             //             .map(child => {
    //             //                 if (child.type === 'a'){
    //             //                     return (<a href={child.properties.url}>{child.properties.title}</a>)
    //             //                 }
    //             //                 if (child.type === 'span'){
    //             //                     return (<span>{child.properties.name}</span>)
    //             //                 }
    //             //                 })    
    //             //         }</ul></li>
    //             //     )
    //             // }
                        
    //         }

    //         if (elementToAdd !== ""){
    //             _trueNav.push(elementToAdd)
    //         }

    //         return await _makeNav(count+1)
    //     }

    //     async function makeListItem(count){
    //         // can contain: span, ul or li

    //     }

    //     async function makeUL(count){
    //         // can contain: li

    //     }

    //     async function makeAnchor(count){

    //     }

    //     async function makeSpan(count){

    //     }

    //     async function makeElement(count, startElem){
    //         let elementsToReturn = []
    //         count += 1
    //         let currentElem = propNav[count]
    //         let endElem = _.cloneDeep(startElem)
    //         endElem.type = 'end'
    
    //         // console.log(startElem.element, currentElem.element, currentElem.type)
    
    
    //         while(count < propNav.length && !(_.isEqual(currentElem, endElem))){
    //             let endIndex = count
    //             if (currentElem.element === "a" || currentElem.element === "span"){
    //                 if(currentElem.element === "a" && currentElem.type === "start"){
    //                     elementsToReturn.push(<a href={currentElem.properties.url}>{currentElem.properties.title}</a>)
    //                     count += 1
    //                 }
    //                 if (currentElem.element === "span" && currentElem.type === "start"){
    //                     elementsToReturn.push(<span>{currentElem.properties.title}</span>)
    //                     count +=1
    //                 }
    //             } else {
    //                 if (currentElem.element === "ul" &&  currentElem.type === "start"){
    //                     elementsToReturn.push(<ul>{await makeElement(count, currentElem)}</ul>)
    //                     for (let elem in propNav){
    //                         if (propNav[elem].element === currentElem.element
    //                             && propNav[elem].properties.id === currentElem.properties.id
    //                             && propNav[elem].type === 'end'){
    //                                 endIndex = elem
    //                         }
    //                     }
    //                     count = parseInt(endIndex)
    //                 }
    
    //                 if (currentElem.element === "li" &&  currentElem.type === "start"){
    //                     elementsToReturn.push(<li key={currentElem.properties.id}>{await makeElement(count, currentElem)}</li>)
    //                     for (let elem in propNav){
    //                         if (propNav[elem].element === currentElem.element
    //                             && propNav[elem].properties.id === currentElem.properties.id
    //                             && propNav[elem].type === 'end'){
    //                                 endIndex = elem
    //                         }
    //                     }
    //                     count = parseInt(endIndex)
    //                 }

    //                 currentElem = propNav[count]

    //                 // if (currentElem.type === "end"){
    //                 //     return elementsToReturn
    //                 // }
    //             }
    
    //             count+=1
    //             currentElem = propNav[count]
    //         }
    //         return elementsToReturn
    //     }

    //     await _makeNav(count)

    //     setTrueNav(_trueNav)
    // }

    useEffect(() => {
        const script = document.createElement('script');
      
        script.type = 'text/javascript'
        
        script.innerHTML =  `function setView(name){
            let view = document.getElementById('view').children[1]
            let props = JSON.parse((name.replace(/'/g, '"')))
            if (props.type === "Page"){
                if (props.shift_page){
                    view.innerHTML = \`
                    <p><b>Type</b>: \${props.type} - Shift</p>
                    <p><b>Title</b>: \${props.title}</p>
                    <hr/>
                    <p><b>URL</b>: \${props.pre_shift_url}</p>
                    <hr/>
                    <p><b>Layer</b>: \${props.layer}</p>
                    <a href="\${props.pre_shift_url}" target="_blank">View Original Page
                    <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root" 
                        focusable="false" 
                        aria-hidden="true"
                        viewBox="0 0 24 24" data-testid="DoubleArrowOutlinedIcon">
                        <path d="M15.5 5H11l5 7-5 7h4.5l5-7z"></path>
                        <path d="M8.5 5H4l5 7-5 7h4.5l5-7z"></path>
                    </svg>
                    </a>
                    \`
                } else {
                    view.innerHTML = \`
                    <p><b>Type</b>: \${props.type}</p>
                    <p><b>Title</b>: \${props.title}</p>
                    <hr/>
                    <p><b>URL</b>: \${props.url}</p>
                    <hr/>
                    <p><b>Layer</b>: \${props.layer}</p>
                    <a href="\${props.url}" target="_blank">View Original Page
                    <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root" 
                        focusable="false" 
                        aria-hidden="true"
                        viewBox="0 0 24 24" data-testid="DoubleArrowOutlinedIcon">
                        <path d="M15.5 5H11l5 7-5 7h4.5l5-7z"></path>
                        <path d="M8.5 5H4l5 7-5 7h4.5l5-7z"></path>
                    </svg>
                    </a>
                    \`
                }
            } else {
                view.innerHTML = \`                
                <p><b>Type</b>: \${props.type}</p>
                <p><b>Path</b>: \${props.name}</p>
                <hr/>
                <p><b>Layer</b>: \${props.layer}</p>
                \`
            }
            
            view.dataset.id = props.id
        }` 

        
        document.body.appendChild(script)      

      }, []);
    

    return(
        <>
            <section className='adjuster'>
                <h1>Adjust</h1>
                <article id='navCode'
                    dangerouslySetInnerHTML={{__html: props.nav}}>
                </article>

                {/* <article id='navCode'>
                    <ul>
                        {trueNav}
                    </ul>
                </article> */}

                <aside id='view'>
                <h1 onClick={() => setViewState(!viewState) }
                    >Selected Properties {viewState ? <ExpandMoreIcon/> : <ExpandLessIcon/>} </h1>
                    <div style={{display:viewState ? "block" : "none"}}></div>
                </aside>

                <button 
                    onClick={(e) => {
                        e.preventDefault()
                        props.toExport()
                    }}>
                    Next <DoubleArrowOutlinedIcon/>
                </button>
            </section>            
        </>
    )
}

export default Adjust